import {useState,useEffect} from "react";
import CurrencyInput from "react-currency-input-field";
import './Incdeccounter.css'
function IncDecCounter(props){

  
  let [num, setNum]= useState(props?.startnumber);
  let incNum =()=>{
    setNum(Number(num)+props?.increment ?? 1);
  };
  let decNum = () => {
     if(num>props?.startnumber)
     {
      setNum(num - props?.increment ?? 1);
     }
  }
 let handleChange = (e)=>{
   setNum(e);
 
  }


useEffect(() => {
  if(props?.startnumber){
  setNum(props?.startnumber)
  }
}, [props?.increment, props?.startnumber])

useEffect(() => { 
  props.setnumber(num);
}, [num, props]);

   return(
    <>
    <div className="input-group incdeccounter">
  <div className="input-group-prepend z-index-0">
    <button className="btn btn-outline-primary" type="button" onClick={decNum}>-</button>
  </div>
  <CurrencyInput
  //{...props}
  name="counter"
  prefix="$"
  className="form-control"
  placeholder="Please enter a number"
  // defaultValue={num}
  value={num}
  decimalsLimit={5}
   onValueChange={(value, name) => handleChange(value)}
  
/>
    <div className="input-group-prepend z-index-0">
    <button className="btn btn-outline-primary" type="button" onClick={incNum}>+</button>
  </div>
</div>
   </>
  );
}

export default IncDecCounter;